import getTabName from './getTabName';
import mergeSubmenus from './mergeSubmenus';

/**
 * @async
 * @function makeSubTabObj
 * @param { array } subTabs
 * @param { array } tabs
 * @returns { Promise<object> }
 */
function makeSubTabObj(subTabs, tabs) {
	const _subTabs = subTabs.reduce((accu, menu) => {
		const _name = getTabName(menu.submenuId, tabs);

		if (accu[_name] === null || accu[_name] === undefined) {
			accu[_name] = [];
		}

		accu[_name].push(menu);
		return accu;
	}, {});

	return _subTabs;
}

/**
 * @async
 * @function makeSubTabs
 * @param { object } tabs
 * @returns { Promise<Array> }
 */
function makeSubTabs(tabs) {
	const subTabs = Object.entries(tabs).map((value, index) => {
		return { id: index, name: value[0], subtabs: value[1] };
	});
	return subTabs;
}

/**
 * @async
 * @function makeGroupBySubMenus
 * @param { array } apps
 * @returns { Promise<Array> } apps
 */
async function makeGroupBySubMenus(apps, tabs) {
	for (let i = 0; i < apps.length; i++) {
		let _tabs = [];
		let _subTabs = [];

		for (let j = 0; j < apps[i].tabs.length; j++) {
			if (apps[i].tabs[j].submenuId === '0') {
				_tabs.push(apps[i].tabs[j]);
			} else if (apps[i].tabs[j].submenuId !== '0') {
				_subTabs.push(apps[i].tabs[j]);
			}
		}

		const __subTabs = await makeSubTabObj(_subTabs, tabs);
		const ___subTabs = await makeSubTabs(__subTabs);
		apps[i].tabs = await mergeSubmenus(_tabs, ___subTabs);
	}

	return apps;
}

export default makeGroupBySubMenus;
